import MetodoBusquedaCole from "./componentesSecundarios/MetodoBusquedaCole";
import CajaBuscador from "./componentesSecundarios/CajaBuscador";
export default function CajitaBuscador() {
return (
    <div className="searchGLobalBOX" id="searchGLobalBOX">
        <CajaBuscador />
        <MetodoBusquedaCole />
    </div>
);
}
